// neo_cogym — 좌석 관리 (W9 + 좌석배정 버그수정)
// 좌석풀별: 잔여 좌석 + 학생 이메일로 배정 + 활성 배정 목록(회수 버튼).

import { useEffect, useState } from "react";
import {
  getSeatPools,
  assignSeat,
  releaseSeat,
  getSeatAssignments,
  type SeatPool,
  type SeatAssignment,
} from "../api/seats";

export function SeatAdmin() {
  const [pools, setPools] = useState<SeatPool[]>([]);
  const [emails, setEmails] = useState<Record<string, string>>({});
  const [assignments, setAssignments] = useState<Record<string, SeatAssignment[]>>({});
  const [msg, setMsg] = useState<string | null>(null);

  const loadPools = () => getSeatPools().then((r) => setPools(r.pools)).catch((e) => setMsg(e.message));
  const loadAssignments = (poolId: string) =>
    getSeatAssignments(poolId)
      .then((r) => setAssignments((s) => ({ ...s, [poolId]: r.assignments })))
      .catch(() => {});

  useEffect(() => {
    loadPools();
  }, []);
  useEffect(() => {
    pools.forEach((p) => loadAssignments(p.id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pools]);

  const onAssign = async (poolId: string) => {
    setMsg(null);
    const id = (emails[poolId] ?? "").trim();
    if (!id) return;
    try {
      await assignSeat(poolId, id);
      setMsg(`배정 완료: ${id}`);
      setEmails((s) => ({ ...s, [poolId]: "" }));
      loadPools();
      loadAssignments(poolId);
    } catch (e) {
      setMsg((e as Error).message);
    }
  };

  const onRelease = async (poolId: string, assignmentId: string) => {
    setMsg(null);
    try {
      await releaseSeat(assignmentId);
      setMsg("좌석 회수 완료");
      loadPools();
      loadAssignments(poolId);
    } catch (e) {
      setMsg((e as Error).message);
    }
  };

  return (
    <div className="seat-admin">
      <h3>좌석 관리</h3>
      {msg && <div className="seat-msg">{msg}</div>}
      {pools.length === 0 ? (
        <p>좌석풀이 없습니다. 좌석팩을 구매하면 여기에 표시됩니다.</p>
      ) : (
        <ul className="seat-pool-list">
          {pools.map((p) => (
            <li key={p.id}>
              <div className="seat-pool-head">
                <b>{p.product_title}</b> — {p.seats_used}/{p.seats_total} 사용
                {p.valid_until && <span className="seat-exp"> (만료 {p.valid_until.slice(0, 10)})</span>}
              </div>
              <div className="seat-assign-row">
                <input
                  type="email"
                  placeholder="학생 이메일 (예: student1@school.kr)"
                  value={emails[p.id] ?? ""}
                  onChange={(e) => setEmails((s) => ({ ...s, [p.id]: e.target.value }))}
                  onKeyDown={(e) => e.key === "Enter" && onAssign(p.id)}
                />
                <button
                  disabled={!(emails[p.id] ?? "").trim() || p.seats_used >= p.seats_total}
                  onClick={() => onAssign(p.id)}
                >
                  배정
                </button>
              </div>
              {(assignments[p.id]?.length ?? 0) > 0 && (
                <ul className="seat-assignment-list">
                  {assignments[p.id].map((a) => (
                    <li key={a.id}>
                      <span>{a.display_name ?? a.email ?? a.id}</span>
                      <button onClick={() => onRelease(p.id, a.id)}>회수</button>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
